import { Card, Typography } from "antd";

const { Text, Title } = Typography;



export function StatCard(props) {
  const { title, value, subtitle, icon, iconBg, style, trend, prefix, titleStyle, valueStyle, subtitleStyle } = props;

  return (
    <Card
  hoverable
  style={{
    borderRadius: 18,
    border: "1px solid #edf1f5",
    background: "#ffffff",
    boxShadow: "0 2px 10px rgba(15,23,42,0.05)",
    transition: "all 0.25s ease",
    height: 120,
    width: "100%",
    overflow: "hidden",
    fontFamily:"Segoe UI Variable Text" ,
    ...style,
  }}
  styles={{
    body: {
      padding: 15,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
    },
  }}
  
  
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    }}
  >
    <div style={{ flex: 1 }}>
      {/* Small Label */}
      <Text
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: "#667085",
          textTransform: "uppercase",
          letterSpacing: 0.8,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
         
        }}
      >
        {title}
      </Text>

      {/* Main Value */}
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: 4,
          marginTop: 6,
        }}
      >
        {prefix && (
          <span
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: "#64748b",
            }}
          >
            {prefix}
          </span>
        )}

        <Title
          level={2}
          style={{
            margin: 0,
            fontWeight: 700,
            color: "#3c3c3e",
            lineHeight: 1,
            fontSize: 32,
            ...valueStyle,
          }}
        >
          {value}
        </Title>
      </div>

      {/* Sub Label */}
      <Text
        style={{
          color: "#767c85",
          fontSize: 12,
          marginTop: 6,
          display: "block",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...subtitleStyle,
        }}
      >
        {subtitle || ""}
      </Text>
    </div>

    {/* Icon */}
    <div
      style={{
        width: 30,
        height: 30,
        borderRadius: "12px",
        background: iconBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 18,
        fontWeight: 700,
        flexShrink: 0,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      {icon}
    </div>
  </div>

  {/* Bottom Section */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 18,
      paddingTop: 12,
    }}
  >

  
  

  </div>
</Card>
  );
}